define('boxes/deposit-result-box',['jquery', 'boxes/events/bonus-event', 'boxes/events/paymentEvent', 'boxes/box', 'boxes/events/signUpEvent',
		'all/comeon', 'boxes/helpers/box-loading', 'boxes/helpers/payment-helpers', 'all/tracking-event',
		'payment/paymentOperationMetadata'],
	function ($, bonusEvent, paymentEvent, box, signUpEvent, comeon, boxLoading, paymentHelpers,
			  trackingEvent,paymentOperationMetadata) {
		'use strict';

		function init(depositResult) {
            depositResult.$controller.on(paymentEvent.IS_INSTANT_DEPOSIT, function(){
                depositResult.$box.find('.defaultlinks').hide();
                depositResult.$box.find('.instantdepositlinks').show();
                depositResult.$box.find('.instantdepositlinks .form-group a').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $('#sliding-content-wrapper', parent.document.body).find('.close').click();
                });
            });

            depositResult.$controller.on(paymentEvent.IS_NORMAL_DEPOSIT, function(){
                depositResult.$box.find('.defaultlinks').show();
                depositResult.$box.find('.instantdepositlinks').hide();
            });

			depositResult.$controller.on(paymentEvent.PENDING, function (event, messageData) {
				depositResult.model.messageClass = '.pending';
				var $pendingInfo = depositResult.$box.find('.pending-info');
                var $defaultPendingInfo = depositResult.$box.find('.default-pending-info');
				if (messageData !== undefined) {
					$pendingInfo.show();
					$defaultPendingInfo.hide();
					$.each(messageData, function (key, value) {
                        paymentHelpers.updateTextOrHtml($pendingInfo.find('.' + key), value);
					});
				} else {
					$pendingInfo.hide();
					$defaultPendingInfo.show();
				}
			});

			depositResult.$controller.on('provider-result', function (event, receiptData) {
				depositResult.model.messageClass = '.provider-result';
                paymentHelpers.updateTextOrHtml(depositResult.$box.find('.provider-result-detail'), receiptData.text);
			});

            depositResult.$controller.on('provider-html', function (event, html) {
                $(depositResult.model.providerHtml).remove();
                depositResult.model.providerHtml = html;
                depositResult.model.showProviderInfo = true;
            });

			depositResult.$controller.on(bonusEvent.NO_SELECTED_BONUS, function () {
				depositResult.model.messageClass = '.deposit';
                depositResult.model.checkFreeMoneyBonusVerification = false;
				depositResult.model.fromCarousel = false;
                depositResult.model.freeMoneyBonusId = -1;
			});

			depositResult.$controller.on(bonusEvent.BONUS_CHANGED, function (event, bonusData) {
				depositResult.model.messageClass = '.deposit-with-bonus';
                depositResult.model.checkFreeMoneyBonusVerification = false;
				depositResult.model.fromCarousel = false;
				if (bonusData.isFree === true) {
					depositResult.model.checkFreeMoneyBonusVerification = true;
					depositResult.model.freeMoneyBonusId = bonusData.id;
					depositResult.model.fromCarousel = bonusData.fromCarousel;
                    depositResult.model.messageClass = '.no-deposit';
				}
			});

            depositResult.$controller.on(paymentEvent.TOTAL_BALANCE_AFTER_TRANSACTION, function(event, totalBalance){
                var $totalBalance = depositResult.$box.find('.total-balance');
                $totalBalance.text(totalBalance);
            });

            depositResult.$controller.on(paymentEvent.PIXEL_TRACKING, function(event, pixelTrackingData){
                var $pixelTrackingDiv = depositResult.$box.find('.pixel-tracking');
                $pixelTrackingDiv.html(pixelTrackingData);
				// trackingEvent.add(trackingEvent.DEPOSIT_CATEGORY, trackingEvent.COMPLETED_ACTION);
            });

            depositResult.$controller.on('no-deposit', function() {
                depositResult.model.messageClass = '.no-deposit';
            });

			depositResult.$box.find('.defaultlinks').show();
			depositResult.$box.find('.instantdepositlinks').hide();
		}

		function freeMoneyBonusResult(depositResult) {
			var freeMoneyPromise = comeon.promise.create();
			if (depositResult.model.checkFreeMoneyBonusVerification) {
				boxLoading.showLoading(depositResult.$box);
				$.ajax({
					url: '/pp?flow=GetDepositVerification',
					data: {isBonusSelected: true, isBonusFree: true},
					type: 'GET'
				}).done(function (data) {
					if (!data.verifyEmail && !data.verifyMobile) {
						$.ajax({
							url: '/pp?flow=RedeemFreeBonus',
							data: {PARAM_BONUS_ID: depositResult.model.freeMoneyBonusId},
							type: 'GET'
						}).done(function () {
							freeMoneyPromise.resolve();
						}).fail(function () {
							freeMoneyPromise.resolve();
						});
					}
				}).fail(function () {
					freeMoneyPromise.resolve();
				}).always(function () {
					boxLoading.removeLoading(depositResult.$box);
				});
			} else {
				freeMoneyPromise.resolve();
			}
			return freeMoneyPromise.promise();
		}

		function renderMessage(depositResult) {
			var $messageElements = depositResult.$box.find('.message');
			$messageElements.hide();

            var $messageElement = depositResult.$box.find('.message' + depositResult.model.messageClass);

            if (depositResult.model.showProviderInfo) {
                var $providerHtml = $(depositResult.model.providerHtml);
                $providerHtml.addClass('provider-html');
                $providerHtml.appendTo($messageElement);
                depositResult.model.showProviderInfo = false;
            } else {
                $('.provider-html').remove();
            }
            $messageElement.show();
		}

		function firstDepositTrackingNameModifier(result, depositResult) {
			var trackingDeposit;
			if (result) {
				trackingDeposit = 'first ' + depositResult.$box.data('trackingName');
			} else {
				trackingDeposit = depositResult.$box.data('trackingName');
				trackingDeposit = trackingDeposit.replace('first ', '');
			}
			depositResult.$box.data('trackingName', trackingDeposit);
		}

		var view = {
				render: function (depositResult) {
					renderMessage(depositResult);
					// Reset render message until next time
					depositResult.model.modeClass = '.deposit';
				}
			},
			model = {
				messageClass: '.deposit',
				checkFreeMoneyBonusVerification: false,
				freeMoneyBonusId: -1,
                showProviderInfo: false,
                providerHtml: undefined,
				init: function (depositResult) {
					init(depositResult);
				},
				beforeRender: function (depositResult) {
					depositResult.$controller.trigger(signUpEvent.SLIDE_ICON);
					$.when(paymentOperationMetadata.checkFirstPaymentOperation()).done(function(result){
						firstDepositTrackingNameModifier(result, depositResult);
					});
					var freeMoneyPromise = freeMoneyBonusResult(depositResult);
					return [freeMoneyPromise];
				},
				afterRender: function() {

				}
			};

		return {
			create: function ($box, $controller) {
				return box.create($box, $controller, view, model);
			}
		};
	});

